(() => {
  const tiers = {
      "chelsea-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "richmond-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "camden-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "clifton-pivot-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "belgravia-magnetic-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "ashford-travertine-duo-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "marlowe-linen-swing-arm-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "norwood-rotatable-rechargeable-wall-light": {
          "pair": 12,
          "four": 20
      },
      "cavendish-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "pembroke-metal-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "lynton-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "cotswold-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "rowan-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "aster-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "vale-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "montrose-aluminium-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "selby-metal-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "marston-waterproof-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "livia-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "oslo-short-ip65-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "oslo-long-ip65-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "ealing-compact-ip65-linear-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "ealing-long-ip65-linear-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "ely-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "farringdon-small-rectangular-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "farringdon-large-rectangular-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "bayswater-small-geometric-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "bayswater-large-geometric-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "hampstead-compact-up-down-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "hampstead-tall-up-down-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "alder-short-waterproof-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "alder-medium-waterproof-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "wren-waterproof-gooseneck-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "portobello-brass-lantern-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "islington-metal-lantern-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "soho-glass-bronze-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "dulwich-black-waterproof-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "hackney-compact-waterproof-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "notting-large-glass-lantern-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "aaradhya-short-rotatable-linear-wall-light": {
          "pair": 12,
          "four": 20
      },
      "mayfield-waterproof-ip55-solar-outdoor-light": {
          "pair": 12,
          "four": 20
      },
      "york-waterproof-solar-outdoor-light": {
          "pair": 12,
          "four": 20
      },
      "windsor-solar-outdoor-light": {
          "pair": 12,
          "four": 20
      },
      "brixton-brass-plug-in-wall-light": {
          "pair": 12,
          "four": 20
      },
      "holborn-linear-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "kew-rotatable-cylinder-rechargeable-wall-light": {
          "pair": 12,
          "four": 20
      },
      "stamford-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "oakley-long-linear-rechargeable-wall-light": {
          "pair": 12,
          "four": 20
      },
      "bromley-walnut-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "shoreditch-linear-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "berkley-linear-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "amara-linear-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "elowen-linear-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "camber-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "barton-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "walton-linear-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "auburn-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "sloane-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "fitzrovia-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "westbourne-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "primrose-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "holland-linear-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "kenwood-duo-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "finchley-battery-wall-light": {
          "pair": 12,
          "four": 20
      },
      "rosedale-travertine-wall-light": {
          "pair": 12,
          "four": 20
      },
      "langham-travertine-acrylic-wall-light": {
          "pair": 12,
          "four": 20
      },
      "belgravia-walnut-travertine-reading-wall-light": {
          "pair": 12,
          "four": 20
      },
      "meridian-travertine-waterproof-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "whitby-travertine-round-wireless-wall-sconce": {
          "pair": 12,
          "four": 20
      },
      "primrose-light-wood-rotatable-travertine-wall-light": {
          "pair": 12,
          "four": 20
      },
      "stratford-travertine-cone-wall-light": {
          "pair": 12,
          "four": 20
      },
      "winchester-travertine-wall-light": {
          "pair": 12,
          "four": 20
      },
      "holland-white-marble-wall-light": {
          "pair": 12,
          "four": 20
      },
      "kingston-alabaster-wall-light": {
          "pair": 12,
          "four": 20
      },
      "radley-marble-wall-light": {
          "pair": 12,
          "four": 20
      },
      "eaton-alabaster-outdoor-wall-light": {
          "pair": 12,
          "four": 20
      },
      "chiswick-marble-wall-light": {
          "pair": 12,
          "four": 20
      },
      "lansdowne-wood-wall-light-plain": {
          "pair": 12,
          "four": 20
      },
      "avon-resin-round-wall-light": {
          "pair": 12,
          "four": 20
      },
      "corby-resin-wall-light": {
          "pair": 12,
          "four": 20
      },
      "stoneham-fabric-wall-light": {
          "pair": 12,
          "four": 20
      },
      "dorset-travertine-wall-light": {
          "pair": 12,
          "four": 20
      },
      "moreton-glass-round-wireless-wall-sconce": {
          "pair": 12,
          "four": 20
      },
      "lumiere-glass-wireless-wall-sconce": {
          "pair": 12,
          "four": 20
      },
      "aveline-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "brentwood-aluminium-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "pimlico-fabric-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "huxley-travertine-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "bramley-marble-glass-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "fenton-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "leighton-aluminium-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "mila-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "grosvenor-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "parker-wood-mushroom-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "rafferty-acrylic-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      },
      "tavistock-solar-cordless-table-lamp": {
          "pair": 12,
          "four": 20
      }
  };

  const money = (cents) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format((Number(cents) || 0) / 100);
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  let requestId = 0;

  function isSetDiscountTitle(title) {
    const t = String(title || '').toLowerCase();
    return t.includes('noxveli bundle') || t.includes('westbourne pair') || t.includes('moreton pair');
  }

  function actualSetSaving(cart) {
    let total = 0;
    (cart.items || []).forEach((item) => {
      const discounts = (item.discounts && item.discounts.length) ? item.discounts : (item.line_level_discount_allocations || []);
      discounts.forEach((discount) => {
        const title = discount.title || (discount.discount_application && discount.discount_application.title) || '';
        if (!isSetDiscountTitle(title)) return;
        total += Number(discount.amount != null ? discount.amount : discount.total_allocated_amount || 0);
      });
    });
    return total;
  }

  function candidateOffers(cart) {
    const out = [];
    const eligibleQuantity = (cart.items || []).reduce((sum, item) => sum + (tiers[item.handle || item.product_handle || ''] ? Number(item.quantity) || 0 : 0), 0);
    if (eligibleQuantity >= 4) return out;
    (cart.items || []).forEach((item, index) => {
      const handle = item.handle || item.product_handle || '';
      const tier = tiers[handle];
      if (!tier) return;
      const q = Number(item.quantity) || 1;
      const unit = Number(item.original_price || item.price || 0);
      if (!unit) return;
      if (q === 1 && tier.pair > 0) {
        const full = unit * 2;
        const total = (unit - Math.floor(unit * tier.pair / 100)) * 2;
        out.push({ line:index + 1, current:q, target:2, add:1, rate:tier.pair, full, total, saving:full-total, title:item.product_title || item.title || 'your light' });
      }
      if (q < 4 && tier.four > 0 && !(q === 1 && tier.pair > 0)) {
        const full = unit * 4;
        const total = (unit - Math.floor(unit * tier.four / 100)) * 4;
        out.push({ line:index + 1, current:q, target:4, add:4-q, rate:tier.four, full, total, saving:full-total, title:item.product_title || item.title || 'your light' });
      } else if (q >= 2 && q < 4 && tier.four > 0) {
        const full = unit * 4;
        const total = (unit - Math.floor(unit * tier.four / 100)) * 4;
        out.push({ line:index + 1, current:q, target:4, add:4-q, rate:tier.four, full, total, saving:full-total, title:item.product_title || item.title || 'your light' });
      }
    });
    return out.sort((a,b) => (a.add-b.add) || (b.rate-a.rate) || (a.line-b.line));
  }

  function nextOffer(cart) { return candidateOffers(cart)[0] || null; }

  function panelHtml(cart) {
    const saving = actualSetSaving(cart);
    const offer = nextOffer(cart);
    if (!saving && !offer) return '';
    let html = '<div class="nv-cart-set-cro" data-nv-cart-bundle-cro>';
    if (saving > 0) {
      html += '<div class="nv-cart-set-cro__saving"><div class="nv-cart-set-cro__saving-copy"><span class="nv-cart-set-cro__eyebrow">Set saving applied</span><p>Your automatic multi-light saving is already included in the basket total.</p></div><strong>-' + money(saving) + '</strong></div>';
    }
    if (offer) {
      const heading = offer.target === 2 ? 'Make it a pair — save ' + offer.rate + '%' : 'Complete a set of four — save ' + offer.rate + '%';
      const button = offer.target === 2 ? 'Make it a pair' : 'Complete set of four';
      html += '<div class="nv-cart-set-cro__offer"><div><span class="nv-cart-set-cro__eyebrow">Complete your set</span><h3>' + heading + '</h3><p><b>' + offer.target + ' for ' + money(offer.total) + '</b> · ' + money(offer.full) + ' at today\'s single-light price · save ' + money(offer.saving) + '</p></div><button type="button" class="nv-cart-set-cro__button" data-nv-set-target="' + offer.target + '" data-nv-cart-line="' + offer.line + '">' + button + '</button></div>';
    }
    html += '<p class="nv-cart-set-cro__note">Set comparison uses today’s single-light price × quantity. Eligible savings apply automatically; no code is needed. Free UK delivery.</p></div>';
    return html;
  }

  function fixLegacyTrustCopy() {
    document.querySelectorAll('.noxveli-page .nx-trust-row span').forEach((el) => {
      
    });
  }

  async function render() {
    fixLegacyTrustCopy();
    const id = ++requestId;
    const targets = [...document.querySelectorAll('.cart-drawer__summary, .cart-summary__inner')].filter((target) => !target.closest('.cart-drawer__summary') || target.classList.contains('cart-drawer__summary'));
    if (!targets.length) return;
    try {
      const response = await fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (id !== requestId) return;
      document.querySelectorAll('[data-nv-cart-bundle-cro]').forEach((el) => el.remove());
      if (!cart.items || !cart.items.length) return;
      const html = panelHtml(cart);
      if (!html) return;
      targets.forEach((target) => target.insertAdjacentHTML('afterbegin', html));
    } catch (error) {
      console.warn('NoxVeli set-pricing cart panel could not refresh.', error);
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('[data-nv-set-target]');
    if (!button) return;
    const line = Number(button.dataset.nvCartLine);
    const quantity = Number(button.dataset.nvSetTarget);
    if (!line || !quantity) return;
    const inDrawer = !!button.closest('.cart-drawer');
    let component = button.closest('cart-items-component');
    if (!component) component = inDrawer ? document.querySelector('cart-items-component[data-drawer]') : document.querySelector('cart-items-component:not([data-drawer])');
    if (!component || typeof component.updateQuantity !== 'function') return;
    button.disabled = true;
    button.textContent = 'Updating…';
    component.updateQuantity({ line, quantity, action: 'change' });
    window.setTimeout(() => { if (button.isConnected) { button.disabled = false; render(); } }, 3000);
  });

  document.addEventListener('cart:update', () => window.setTimeout(render, 160));
  document.addEventListener('discount:update', () => window.setTimeout(render, 160));
  document.addEventListener('DOMContentLoaded', () => window.setTimeout(render, 80));
  window.addEventListener('pageshow', () => window.setTimeout(render, 80));
  if (document.readyState !== 'loading') window.setTimeout(render, 80);
})();